module.exports = __webpack_public_path__ + "static/img/product_img_1.fe53c49.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/product_img_1.png
// module id = JMQs
// module chunks = 22